// extracted by mini-css-extract-plugin
module.exports = {"SectionHeader":"styles_SectionHeader__1z5Hz","SectionHeader__Close":"styles_SectionHeader__Close__1QWQ1"};